import { languageExceptions } from '../model/ssr/l10n.ts';

const localeRegexp = /^[/][\w]{2}-[\w]{2}[/]/;
const languageRegexp = /^[/][\w]{2}[/]/;

export function normalizeHref(input, localeOrLanguage) {
    const initialLink = (input || '').trim();

    if (!initialLink) return false;

    const [, proto] = initialLink.match(/^(\w+):/) || [];

    if (['http', 'https', 'tel', 'mailto'].includes(proto)) {
        return initialLink;
    }
    if (proto) {
        return initialLink;
    }
    if (initialLink.startsWith('#')) {
        return initialLink;
    }
    if (initialLink.startsWith('/localize/')) {
        return initialLink;
    }

    const FAKE_DOMAIN = 'https://www.acronis.com';
    const target = new URL(initialLink, FAKE_DOMAIN);

    // ensure trailing slash
    const isFile = Boolean(target.pathname.match(/\.\w+$/));

    if (!isFile) {
        target.pathname = target.pathname.replace(/[/]$/, '');
        target.pathname += '/';
    }

    // fix double slashes if any
    target.pathname = target.pathname.replace(/[/]+/g, '/');

    // inject locale/language if it's not here yet and it's localizable
    const hasLocale = target.pathname.match(localeRegexp);

    const firstSegment = target.pathname.split('/').filter(Boolean)[0];
    const hasLanguage = target.pathname.match(languageRegexp) && !languageExceptions.has(firstSegment);

    if (!isFile && !hasLocale && !hasLanguage) {
        target.pathname = `/${localeOrLanguage}${target.pathname}`;
    }

    return target.toString().replace(FAKE_DOMAIN, '');
}

// Done with regexp replace because isomorphic DOM fragment parser is too heavyweight for this task
export function normalizeHrefsInHtmlFragment(input, localeOrLanguage) {
    const ANCHOR_REGEXP = /<a[^>]*>[^<]*<[/]a>/gi; // to find all occurences of <a...>...</a>
    const HREF_REGEXP = /href=['"]([^'"]+)['"]/i; // to find href="..." attribute inside the anchor HTML fragment

    const hrefReplacer = (attr, href) => attr.replace(href, normalizeHref(href, localeOrLanguage));
    const anchorReplacer = (outerHtml) => outerHtml.replace(HREF_REGEXP, hrefReplacer);
    if (typeof input !== 'string') return input;
    return input.replace(ANCHOR_REGEXP, anchorReplacer);
}
